import {Component} from '@angular/core';
import {DsTabsModule} from '@bmw-ds/components';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.component.html',
  styleUrls: ['./imprint.component.scss'],
  imports: [TranslateModule, DsTabsModule]
})
export class ImprintComponent {
}
